
(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "68faa5694b89f9c9a50a6bd5";
              window.beaePageSetting.pageTitle = "Farm Medix Latest News, Blogs & Articles"; 
              window.beaePageSetting.pageType = "blog";

          let js_UHHHFC0L = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-xe7o0p4lsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-xe7o0p4l',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-xe7o0p4l');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-xe7o0p4l: ', ex)
      };
    

      try {
        let argid = 'beae-lt2q5g3dblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-lt2q5g3d',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-lt2q5g3d');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-lt2q5g3d: ', ex)
      };
    

      try {
        let argid = 'beae-atugz3hkblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-atugz3hk',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-atugz3hk');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-atugz3hk: ', ex)
      };
    

      try {
        let argid = 'beae-fubmr2o7section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-fubmr2o7',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-fubmr2o7');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-fubmr2o7: ', ex)
      };
    

      try {
        let argid = 'beae-m4x2pynrsection-blog-posts-page',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-m4x2pynr',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-m4x2pynr');
        args.el = args.els[0];
        ((a) => { var h;n();function n(){document.querySelectorAll(".beae-blog-paginate--wrp a").forEach(u=>{(!u.hasAttribute("href")||!u.getAttribute("href").trim())&&(u.addEventListener("click",function(f){f.preventDefault()}),u.classList.add("disabled"),u.style.pointerEvents="none",u.style.opacity="0.5")})}const t=window.location.search,o="/blogs/"+((h=a.blog)==null?void 0:h.handle),r=a.el.querySelectorAll(".beae-blog-list button.beae-blog-btn"),l=a.el.querySelectorAll(".beae-blog-list button.beae-blog-tag-btn");r.length>0&&d(r,t),l.length>0&&d(l,t,o),c();const p=a.el.querySelector(".beae-x-blog-posts-page");function d(g,u="",f=""){if(g.length){const b=window.location.pathname;g.forEach(k=>{k.getAttribute("data-url")===b&&k.classList.add("active"),k.addEventListener("click",function(m){var B;g.forEach(w=>{w.classList.remove("active")}),k.classList.add("active");const y=f+((B=k.getAttribute("data-url"))==null?void 0:B.replace(" ","-"));if(!y)return;const S=new URL(window.location.origin+y+u);x(S.href)})})}}function c(){const g=document.querySelectorAll(".beae-blog-paginate .beae-blog-pagination-btn");g.length&&g.forEach(u=>{u.addEventListener("click",function(f){const b=u.getAttribute("data-url");if(!b)return;const k=new URL(window.location.origin+b);x(k.href)})})}let s={};function v(g,u){return new Promise(f=>{const b=a.el.querySelector(u),k=document.createElement("div");k.innerHTML=g;const m=k.querySelector(u);b&&(b.style.height="fit-content",m?b.innerHTML=m.innerHTML:(b.style.height="0px",b.style.overflow="hidden")),f()})}function x(g){if(s={},!p)return;const u=p.getAttribute("section-template-id"),f=new URL(g);let b=f.search?f.search.replace("?",""):"";const k=f.pathname+"?section_id="+u+"&"+b;fetch(k).then(m=>m.text()).then(m=>{s[k]=m,v(m,".beae-x-blog-posts"),v(m,".beae-blog-paginate"),c()}),history.pushState({searchParams:b},"",`${f.pathname}${b&&"?".concat(b)}`)} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-m4x2pynr: ', ex)
      };
    

      try {
        let argid = 'beae-50i2nydiblock-developer',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-50i2nydi',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-50i2nydi');
        args.el = args.els[0];
        ((data
) => { data.el.querySelectorAll('.beae-blog-tag-btn').forEach(button => {
    const url = button.getAttribute('data-url');
    if (url === '/tagged/') {
      button.setAttribute('data-url', '/');
    
    }
    if (button.getAttribute('data-url') === '/') {
      button.classList.add('active');
    }
  }); })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-50i2nydi: ', ex)
      };
    

      try {
        let argid = 'beae-x039gaq3block-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-x039gaq3',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-x039gaq3');
        args.el = args.els[0];
        ((M) => { var P;if(M.el){if(M.shape){const H=M.el.closest(".beae-slider-items");H&&!H.hasAttribute("data-svg")&&(H==null||H.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),H.setAttribute("data-svg","true"))}let O=M.el.querySelector(".beae-image-content-position"),I,z=window.innerWidth>=768&&M.autoHover;var V=O.querySelector(".beae-img-ratio-control"),L=O.querySelector(".beae-img-comp-container"),T=O.querySelector(".beae-img-comp-container--second");if(V&&T){let H=function(A){let R=0,j;D(),z?O.onmouseover=function(Z){q(Z)}:A.onmousedown=function(Z){q(Z)},O.onmouseup=function(){F()},A.ontouchstart=function(Z){q(Z)},O.ontouchend=function(){F()};function D(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),A.style.left&&parseInt(A.style.left)}function q(Z){check=!1,Z.preventDefault(),Z.clientX?Z.clientX:Z.touches[0].clientX,parseInt(A.style.left),R=1,O.onmousemove=function(K){G(K)},O.ontouchmove=function(K){G(K)}}function F(){R=0,check=!0}function G(Z){if(R==0)return!1;j=J(Z),j<0&&(j=0),j>100&&(j=100),W(j)}function J(Z){const K=O.getBoundingClientRect(),le=(Z.changedTouches?Z.changedTouches[0].clientX:Z.clientX)-K.left;return Math.max(0,Math.min(100,Math.round(le*100/I)))}function W(Z){A.style.left=Z+"%",T.style.clipPath=`polygon(${Z}% 0%, ${Z}% 100%, 100% 100%, 100% 0)`,L.style.clipPath=`polygon(0% 100%, 0% 0%, ${Z}% 0%, ${Z}% 100%)`}};V&&T&&H(V),window.addEventListener("resize",function(){V&&T&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),H(V))})}}let N=(P=M.el)==null?void 0:P.querySelector("a.beae-x-image"),E=N==null?void 0:N.getAttribute("href");N&&M.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&N.addEventListener("click",O=>{let I=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(I)return I.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-x039gaq3: ', ex)
      };
    

      try {
        let argid = 'beae-zpoiqaozblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-zpoiqaoz',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-zpoiqaoz');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-zpoiqaoz: ', ex)
      };
    

      try {
        let argid = 'beae-nvrkmg66block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-nvrkmg66',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-nvrkmg66');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-nvrkmg66: ', ex)
      };
    

      try {
        let argid = 'beae-xvmwtx94block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-xvmwtx94',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-xvmwtx94');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-xvmwtx94: ', ex)
      };
    

      try {
        let argid = 'beae-1dc2d35obutton-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-1dc2d35o',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-1dc2d35o');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm==null||buttonElm.addEventListener("click",e=>{var n,t;let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(o){extOptions={},console.error(o)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let o=document.querySelector(selector+","+selector.replace("#","."));if(o)return o.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup"){if(window.isPreviewTemplate){let l=data.el.querySelector(".beae-content-size-chart-preview");window.BeaePopupLibrary.createPopup(l,{id:data.id,...extOptions}),e.preventDefault();return}const o=window.createLoading(e.currentTarget);let r=(t=(n=window.BEAE_HELPER)==null?void 0:n.routes)==null?void 0:t.root_url;return window.BeaePopupLibrary.lightbox({id:data.id,url:(r!=="/"?r:"")+((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}).then(l=>{l.querySelector(".beae-product-form-next")&&window.handleEventFormProductCard(l),o.remove()}),e.preventDefault(),!1}else if(data.type==="pages"&&data.lightbox){let o=data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'");return window.isPreviewTemplate&&(o=data.el.querySelector(".beae-content-size-chart-preview")),window.BeaePopupLibrary.createPopup(o,{id:data.id,...extOptions}),e.preventDefault(),!1}}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((t,o)=>{t.forEach(r=>{r.isIntersecting&&(o.unobserve(r.target),r.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-1dc2d35o: ', ex)
      };
    }; if (window.BEAEBASE) {js_UHHHFC0L()} else {window.BEAEPAGEJS.push(js_UHHHFC0L)} })(); 